import { memo } from "react";

interface LogoProps {
  /** Height in pixels (width auto to preserve aspect ratio). */
  size?: number;
  className?: string;
  /** Logo variant: "full" | "icon" = header, "auth" = login/inscription, "banner" = home hero */
  variant?: "full" | "icon" | "auth" | "banner";
  /** Set to true for LCP image (e.g. header logo) to improve LCP. */
  priority?: boolean;
}

const variantSrc: Record<NonNullable<LogoProps["variant"]>, string> = {
  full: "/logo-banner.png",
  icon: "/logo-banner.png",
  auth: "/logo-banner.png",
  banner: "/logo-banner.png",
};

const variantAspectRatio: Record<NonNullable<LogoProps["variant"]>, number> = {
  full: 1882 / 469,   // ~4.01
  icon: 1882 / 469,   // ~4.01
  auth: 1882 / 469,   // ~4.01
  banner: 1882 / 469, // ~4.01
};

export const Logo = memo(({ size = 32, className, variant = "full", priority = false }: LogoProps) => {
  const aspectRatio = variantAspectRatio[variant];
  const width = Math.round(size * aspectRatio);

  return (
    <img
      src={variantSrc[variant]}
      alt="KenoMetric"
      className={className}
      style={{ height: size, width, display: "block" }}
      width={width}
      height={size}
      fetchPriority={priority ? "high" : undefined}
    />
  );
});

Logo.displayName = "Logo";
